module.exports = __webpack_public_path__ + "img/banner501.b990402f.jpeg";